import axiosInstance from '../../../../services/axios/axios';
import { WrapImsPacket } from '../../../../store/utility';

/**
 * // Takes TrackingNumber and the List<int> AppIDs and returns the headers for the requestee and requestor
 Phase 1: Just get the requestee
 Phase 2: Get the requestor information as well and package into 1 json
 {Requestor: {}, Requestee: {}}
 *
 */
export const fetchRequestInformation = async workQueueArgs => {
	try {
		const response = await axiosInstance.post(
			`api/WorkQueue/GetRequestInfo`,
			WrapImsPacket(workQueueArgs)
		);
		return response;
	} catch (ex) {
		console.error('Unable to fetch work queue admins: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Returns applications available for processing
 *
 */
export const fetchAppsForProcessing = async workQueueArgs => {
	try {
		const response = await axiosInstance.post(
			`api/WorkQueue/GetApplicationsForProcessing`,
			WrapImsPacket(workQueueArgs)
		);
		return response;
	} catch (ex) {
		console.error(
			'Unable to fetch applications available for processing: ' + ex
		);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Returns applications available for processing
 *
 */
export const fetchOtherApplications = async workQueueArgs => {
	try {
		const response = await axiosInstance.post(
			`api/WorkQueue/GetOtherApplications`,
			WrapImsPacket(workQueueArgs)
		);
		return response;
	} catch (ex) {
		console.error(
			'Unable to fetch applications available for processing: ' + ex
		);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};
